import Ajax from 'global/od/Ajax';

export const experianInvoiceEmailLookup = (emailInputValue, pageType) => {
	return Ajax({
		url: `/ajax/${pageType}/multi/billing/validate/email`,
		method: 'POST',
		dataType: 'html',
		data: {
			invoiceEmailId: emailInputValue,
		},
	});
};
